import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaterangePickerComponent } from "./daterange-picker.component";
import {Daterangepicker} from "ng2-daterangepicker";
import {InputIconModule} from "../input-icon/input-icon.module";
import {IconsModule} from "../icons/icons.module";



@NgModule({
  declarations: [
    DaterangePickerComponent,
  ],
  exports: [
    DaterangePickerComponent
  ],
  imports: [
    CommonModule,
    Daterangepicker,
    InputIconModule,
    IconsModule
  ]
})
export class DaterangePickerModule { }
